{
  "partner": {
    "yobante": "Yobante Express",
    "sawa": "Sawa Delivery",
    "yango": "Yango Delivery",
    "own_fleet": "Djayma Yobaale"
  },
  "slots": {
    "title": "Tànn waxtu indil bi",
    "loading": "Yéegal waxtu yi...",
    "select_zone_date": "Tànnal sa zone ak bés bi.",
    "none_available": "Amul waxtu ci bés bii.",
    "full": "Fees na",
    "remaining": "{{count}} palaas a des",
    "remaining_plural": "{{count}} palaas a des"
  },
  "zone": {
    "title": "Zone indil",
    "from_price": "Tambali ci {{price}}",
    "minutes": "{{count}} simili",
    "hours": "{{count}} waxtu",
    "hours_minutes": "{{hours}} waxtu {{minutes}} simili",
    "zones": {
      "dakar": "Ndakaaru",
      "thies-mbour": "Cees-Mbuur",
      "kaolack": "Kaolack",
      "saint-louis": "Ndar",
      "fatick": "Fatig",
      "diourbel-touba": "Jurbel-Tuubaa"
    }
  },
  "tracking": {
    "title": "Topp indil bi",
    "status": {
      "pending": "Ci xaar",
      "preparation": "Ñuy prepare",
      "en_route": "Ci yoon wi",
      "arrived": "Agsi na",
      "delivered": "Indil na",
      "cancelled": "Neenal na"
    },
    "cancelled": "Indil bii neenal nañu ko.",
    "driver_info": "Sa livreur",
    "estimated_arrival": "Waxtu agsi :",
    "map_placeholder": "Topp ci waxtu wi dina am ci kanam"
  },
  "yango": {
    "title": "Konsol Yango",
    "subtitle": "Yóbbu te topp indil yi ak Yango",
    "refresh": "Yeesal",
    "dispatch": "Yóbbu ak Yango",
    "confirm_dispatch": "Dëggal yóbbu {{ref}}?",
    "confirm": "Dëggal",
    "cancel_action": "Neenal",
    "search_placeholder": "Wut ci commande, kilifay walla adres...",
    "empty": "Amul yóbbu Yango ba léegi.",
    "error": "Mënuloo yéegal yóbbu yi. Jéema kenn yenn.",
    "retry": "Jéema kenn yenn",
    "filter": {
      "all": "Yépp",
      "pending": "Ci xaar",
      "searching": "Ñuy wut",
      "in_transit": "Ci yoon",
      "delivered": "Indil na",
      "failed": "Jàllatu na",
      "cancelled": "Neenal na"
    },
    "status": {
      "pending": "Ci xaar",
      "searching_driver": "Ñuy wut chauffeur",
      "driver_assigned": "Chauffeur tëral nañu",
      "pickup_arrived": "Agsi na ci point bi",
      "in_transit": "Ci yoon",
      "delivered": "Indil na",
      "cancelled": "Neenal na",
      "failed": "Jàllatu na"
    },
    "col": {
      "order_ref": "Commande",
      "customer": "Kilifay",
      "address": "Adres indil",
      "status": "Estatü",
      "driver": "Chauffeur",
      "cost": "Njëg",
      "date": "Bés"
    },
    "kpi": {
      "total_dispatches": "Yóbbu yépp",
      "total_cost": "Njëg total",
      "avg_cost": "Njëg moyen",
      "pending": "Ci jëm",
      "delivered": "Indil nañu",
      "failed": "Jàllatu nañu"
    }
  }
}
